import React from "react";
import { useTranslation } from "react-i18next";
import "../assets/styles/Education.scss";

const educationItems = [
  { key: "master", url: "https://uit.no/utdanning/program/795107/computer_science_-_master" },
  { key: "engineering" },
  { key: "kindergarten" },
];

function Education() {
  const { t } = useTranslation();

  return (
    <section className="education-container" id="education">
      <h1>{t("education.title")}</h1>
      <p className="education-intro">{t("education.intro")}</p>
      <div className="education-grid">
        {educationItems.map((item) => (
          <article className="education-card" key={item.key}>
            <p className="education-period">{t(`education.${item.key}.period`)}</p>
            {item.url ? (
              <a href={item.url} target="_blank" rel="noreferrer">
                <h2>{t(`education.${item.key}.degree`)}</h2>
              </a>
            ) : (
              <h2>{t(`education.${item.key}.degree`)}</h2>
            )}
            {t(`education.${item.key}.institution`, { defaultValue: "" }) && (
              <p className="education-institution">
                {t(`education.${item.key}.institution`)}
              </p>
            )}
            <p>{t(`education.${item.key}.description`)}</p>
          </article>
        ))}
      </div>
    </section>
  );
}

export default Education;
